<template>
  <div class="sidebar-container p-2">

    <div class="row">
      <div class="col-12">
        <h6 class="mb-2"><strong>{{ headingText }}</strong></h6>
        <template v-if="typesenseResponse && hits.length > 0">

          <ExploreV2TrailCard v-for="hit in hits" :hit="hit" :source="searchSource" :key="hit.document.id" />

          <button class="btn btn-primary btn-block" @click="renderTrailCount += perPage" v-if="moreAvailable">{{ $t('shared.load_more') }}</button>
          <div class="d-block" style="height: 500px;"></div>

        </template>
        <template v-else>
          <div class="card mb-3">
            <div class="p-2">
              <p class="m-0"><strong>{{ emptyText }}</strong></p>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import ExploreV2TrailCard from './ExploreV2TrailCard.vue';

export default {
  components: {
    ExploreV2TrailCard,
  },
  data() {
    return {
      perPage: 5,
      renderTrailCount: 5,
    };
  },
  computed: {
    searchSource() {
      return this.$store.state.exploreV2.searchSource || 'hikes';
    },
    isCommunitySource() {
      return this.searchSource === 'community';
    },
    headingText() {
      return this.isCommunitySource
        ? this.$t('explore_v2.trail_list_side_bar.community_in_this_area')
        : this.$t('explore_v2.trail_list_side_bar.popular_hikes_in_this_area');
    },
    emptyText() {
      return this.isCommunitySource
        ? this.$t('explore_v2.trail_list_side_bar.no_community_activity')
        : this.$t('explore_v2.trail_list_side_bar.no_trails_in_this_area');
    },
    hits() {
      if (!this.typesenseResponse?.hits?.length) {
        return [];
      }
      const trailCount = this.typesenseResponse.hits.length > this.renderTrailCount ? this.renderTrailCount : this.typesenseResponse.hits.length;
      return this.typesenseResponse.hits.slice(0, trailCount);
    },
    moreAvailable() {
      return (this.typesenseResponse?.hits?.length || 0) > this.renderTrailCount;
    },
    searchQuery: {
      get() {
        return this.$store.state.exploreV2.searchString;
      },
      set(value) {
        this.$store.commit('exploreV2/setSearchString', value);
      },
    },
    typesenseResponse() {
      return this.$store.state.exploreV2.typesenseResponse;
    },
  },
};
</script>
